import React from 'react'
import style from './CheckBox.module.css'

interface ICheckBox {
  label: string
}

export const CheckBox: React.FC<ICheckBox> = ({ label }) => (
  <div className={style.containerStyle}>
    <input className={style.checkBox} type="checkbox" id="checkbox" />
    <label htmlFor="checkbox" className={style.labelStyle}>
      {label}
    </label>
  </div>
)
